import { InitSearch } from "./components/initSearch/initSearch.container";
import { Results } from "./components/results/results";
import { SaveScrollPosition } from "./components/saveScrollPosition/saveScrollPosition.container";
import { Skeleton } from "./components/skeleton/skeleton";
import { Base } from "./searchResults.base";

export const SearchResults = Object.assign(Base, {
    Skeleton: Skeleton,
    Results: Results,
    SaveScrollPosition: SaveScrollPosition,
    InitSearch: InitSearch
});
